import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { IndexRebuildStatus } from './index-rebuild-status';

@Injectable()
export class IndexRebuildService {
  protected http = inject(HttpClient);


  public resetIndexes(): Observable<IndexRebuildStatus> {
    return this.http.post<IndexRebuildStatus>(
      '/api/application/reset-indexes',
      null
    );
  }

  public getResetStatus(): Observable<IndexRebuildStatus> {
    return this.http.get<IndexRebuildStatus>(
      '/api/application/reset-indexes-status'
    );
  }
}
